import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Modal de asignación de importes de coste por vehículo.
 * Recibe { vehicles: [{ vehicleId, vin, existingCostId|null, importe }], title }
 * y devuelve { confirm: boolean, items: [{ vehicleId, costId|null, importe }] }
 * (omitiendo las filas con importe vacío).
 */
@Component({
  selector: 'vex-import-costs-dialog',
  templateUrl: './import-costs-dialog.component.html',
  styleUrls: ['./import-costs-dialog.component.scss']
})
export class ImportCostsDialogComponent implements OnInit {

  form: FormGroup;
  title: string;

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<ImportCostsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  get rows(): FormArray {
    return this.form.get('rows') as FormArray;
  }

  ngOnInit(): void {
    this.title = this.data?.title || 'Costes de vehículos';
    const vehicles: Array<any> = this.data?.vehicles || [];
    this.form = this.fb.group({
      rows: this.fb.array(
        vehicles.map(v => this.fb.group({
          vehicleId: [v.vehicleId],
          vin: [v.vin],
          costId: [v.existingCostId ?? null],
          importe: [v.importe ?? null]
        }))
      )
    });
  }

  cancel(): void {
    this.dialogRef.close({ confirm: false, items: [] });
  }

  confirm(): void {
    const items = this.rows.controls
      .map(c => c.value)
      .filter(r => r.importe !== null && r.importe !== undefined && r.importe !== '' && !isNaN(Number(r.importe)))
      .map(r => ({ vehicleId: r.vehicleId, costId: r.costId ?? null, importe: Number(r.importe) }));
    this.dialogRef.close({ confirm: true, items });
  }
}
